angular.module('impactx.dashboard').controller('DashboardCombiBudgetCtrl', ['$scope', 'dataGen', DashboardCombiBudgetCtrl]);

function DashboardCombiBudgetCtrl($scope, dataGen) {
    dataGen.getData($scope, {}, "/dashboard/combibudget").then(function () {
        $scope.isHidden.value = !$scope.data.hasAnyBudget;
    })
}